<template>
  <ais-search-box>
    <template v-slot="{ refine, isSearchStalled }">
      <SloField>
        <SloInput
          v-bind="$attrs"
          type="search"
          v-model="searchValue"
          @input="handleInput($event, refine)"
          role="search"
        >
          <template v-slot:start>
            <SloIcon name="MagnifyingGlass" />
          </template>
          <template v-slot:end>
            <div class="loader-container">
              <SloLoader :loading="isSearchStalled && Boolean(searchValue)" size="md" />
            </div>
          </template>
        </SloInput>
      </SloField>
    </template>
  </ais-search-box>
</template>

<script>
import SloField from '../../lib/components/SloField.vue';
import SloIcon from '../../lib/components/SloIcon.vue';
import SloInput from '../../lib/components/SloInput.vue';
import SloLoader from '../../lib/components/SloLoader.vue';

export default {
  name: 'SloSearchBox',
  components: {
    SloInput,
    SloIcon,
    SloField,
    SloLoader
  },
  computed: {
    searchValue: {
      get() {
        return this.$children[0].currentRefinement;
      },
      set(newValue) {
        return newValue;
      }
    }
  },
  methods: {
    handleInput(value, cb) {
      this.$emit('input', value);
      if (cb) cb(value);
    }
  }
};
</script>

<style lang="scss" scoped>
.slo-input {
  position: relative;
}

.loader-container {
  width: 30px;
  margin-right: 10px;
}
</style>
